import React from 'react';
import { injectIntl } from 'react-intl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const MyMuiPickersUtilsProvider = props => {
  const { intl, children } = props;
  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={intl.locale}
      localeText={{
        // Default placeholder for letter-content months is always "MMMM".
        // Use the actual format token so "MMM" format shows "MMM", not "MMMM".
        fieldMonthPlaceholder: params =>
          params.contentType === 'letter' ? params.format : 'MM'
      }}
    >
      {children}
    </LocalizationProvider>
  );
};

export default injectIntl(MyMuiPickersUtilsProvider);
